import { DictUtil } from 'jczh-ui'
import Dict from '@/utils/dict-utils'

// 费用科目字典
// 收费类型字典
export const feeTypeDict = new DictUtil({
  SIGN_UP_PAY: {
    label: '平台使用费',
    value: 'SIGN_UP_PAY'
  },
  SERVICE_FEE_PAY: {
    label: '服务费',
    value: 'SERVICE_FEE_PAY'
  },
  BOOK_FEE_PAY: {
    label: '标书费',
    value: 'BOOK_FEE_PAY'
  },
  VAS_PAY: {
    label: '平台增值服务',
    value: 'VAS'
  }
})

// 支付方式
export const paymentMethodDict = new DictUtil({
  PING_AN_ALI_QR: {
    label: '支付宝',
    value: 1
  },
  PING_AN_WX_QR: {
    label: '微信',
    value: 2
  },
  PING_AN_DEPOSIT: {
    label: '线下汇款',
    value: 3
  }
})

// 支付结果
export const payResultDict = new Dict({
  PENDING: {
    value: false,
    label: '待支付'
  },
  SUCCESS: {
    value: true,
    label: '已支付'
  }
})

// 开票状态
export const invoicingStatusDict = new DictUtil({
  NOT_APPLY: {
    label: '未申请',
    value: 0,
    type: 'info'
  },
  APPLIED: {
    label: '未开票',
    value: 1,
    type: 'primary'
  },
  INVOICED: {
    label: '已开票',
    value: 2,
    type: 'success'
  },
  REJECTED: {
    label: '已拒绝',
    value: 3,
    type: 'danger'
  }
})

// 发票抬头类型
export const invoiceTitleTypeDict = new DictUtil({
  COMPANY: { label: '企业单位', value: 1 },
  PERSONAL: { label: '个人', value: 2 }
})

// 开票类型
export const invoiceTypeDict = new DictUtil({
  GENERAL_ELECTRONIC_INVOICE: {
    label: '电子普通发票',
    value: 'invoice_normal'
  },
  SPECIAL_PAPER_INVOICE: {
    label: '纸质专用发票',
    value: 'invoice_special'
  }
})

// 是否企业信息
export const isCompanyDict = new DictUtil({
  COMPANY: {
    value: 0,
    label: '企业'
  },
  PERSONAL: {
    value: 1,
    label: '个人'
  }
})

// 发票开具类型
export const invoiceApplyTypeDict = new DictUtil({
  SINGLE_APPLY: {
    label: '单张开票',
    value: 1
  },
  COMBINE_APPLY: {
    label: '合并开票',
    value: 2
  }
})

// 项目类型
export const bizTypeDict = new DictUtil({
  ZB: {
    label: '招标',
    value: 'ZB'
  },
  XB: {
    label: '询比',
    value: 'XB'
  },
  JZ: {
    label: '竞价',
    value: 'JZ'
  },
  NEGOTIATED_PURCHASE: {
    value: 'TP',
    label: '谈判采购'
  },
  VALUE_ADDED: {
    value: 'VAS',
    label: '增值'
  },
  NEGOTIATED_V2: {
    value: 'HTP',
    label: '分项谈判'
  }
})

// 提现状态
export const withdrawalStatusDict = new DictUtil({
  WITHDRAW_ING: {
    label: '提现中',
    value: 0,
    type: 'primary'
  },
  WITHDRAW_ED: {
    label: '已提现',
    value: 1,
    type: 'success'
  },
  WITHDRAW_FAILED: {
    label: '提现失败',
    value: 2,
    type: 'danger'
  }
})

// 保证金预存入账方式
export const guaranteePreSaveReceiptTypeDict = new DictUtil({
  TRANSACTION: { label: '入账', value: 1 },
  REFUND: { label: '退款', value: 2 }
})

// 保证金预存退款方式
export const guaranteePreSaveRefundTypeDict = new DictUtil({
  NO_REFUND: { label: '未退款', value: 0 },
  PARTIAL_REFUND: { label: '部分退款', value: 1 },
  ALL_REFUND: { label: '全部退款', value: 2 }
})

// 保证金预存退款状态
export const guaranteePreSaveRefundStatusDict = new DictUtil({
  NO_REFUND: { label: '未退款', value: 0 },
  IN_REFUND: { label: '退款中', value: 1 },
  SUCCESS_REFUND: { label: '退款成功', value: 2 },
  FAIL_REFUND: { label: '退款失败', value: 3 }
})

// 保证金预存占用状态
export const guaranteePreSaveOccupyStatusDict = new DictUtil({
  PENDING: { label: '待恢复', value: 1 },
  RECOVERED: { label: '已恢复', value: 2 }
})
